// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import SpotServices from "../../services/externalServices/TourPackageServices/spotServices";

// function Spots() {
//   const [spots, setSpots] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     getAllSpots();
//   }, []);

//   const getAllSpots = async () => {
//     try {
//       setLoading(true);
//       const response = await SpotServices.getAllSpots();
//       setSpots(response.data || response);
//       setLoading(false);
//     } catch (err) {
//       setError(err.message);
//       setLoading(false);
//     }
//   };

//   const handleSpotClick = (spotId) => {
//     navigate(`/edit-spot/${spotId}`);
//   };

//   if (loading)
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
//       </div>
//     );

//   if (error)
//     return (
//       <div className="flex justify-center items-center h-screen">
//         <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
//           Error: {error}
//         </div>
//       </div>
//     );

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <div className="flex justify-between items-center mb-8">
//         <h1 className="text-3xl font-bold text-gray-800">Tourist Spots</h1>
//         <button 
//           onClick={() => navigate('/add-spot')}
//           className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
//         >
//           Add New Spot
//         </button>
//       </div>

//       <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//         {spots.map((spot) => (
//           <div
//             key={spot._id}
//             onClick={() => handleSpotClick(spot._id)}
//             className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer"
//           >
//             {/* Thumbnail Image */}
//             <div className="h-48 bg-gray-200 overflow-hidden">
//               {spot.thumbnailImage ? (
//                 <img
//                   src={spot.thumbnailImage}
//                   alt={spot.name.en}
//                   className="w-full h-full object-cover"
//                   onError={(e) => {
//                     e.target.onerror = null;
//                     e.target.src =
//                       "https://via.placeholder.com/400x300?text=No+Image";
//                   }}
//                 />
//               ) : (
//                 <div className="w-full h-full flex items-center justify-center bg-gray-100">
//                   <span className="text-gray-500">No Image Available</span>
//                 </div>
//               )}
//             </div>

//             {/* Card Content */}
//             <div className="p-6">
//               <h2 className="text-xl font-semibold text-gray-800 mb-2">
//                 {spot.name.en}
//                 {spot.name.kn && (
//                   <span className="block text-sm text-gray-600 mt-1">
//                     {spot.name.kn}
//                   </span>
//                 )}
//               </h2>

//               <p className="text-gray-600 mb-4 line-clamp-2">
//                 {spot.description}
//               </p>

//               <div className="flex justify-between items-center">
//                 <div className="flex space-x-2">
//                   {spot.audioGuide.en.isEnabled && (
//                     <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
//                       EN Audio
//                     </span>
//                   )}
//                   {spot.audioGuide.kn.isEnabled && (
//                     <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
//                       KN Audio
//                     </span>
//                   )}
//                 </div>

//                 <div className="text-sm text-gray-500">
//                   {new Date(spot.createdAt).toLocaleDateString()}
//                 </div>
//               </div>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// }

// export default Spots;

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import SpotServices from "../../services/externalServices/TourPackageServices/spotServices";

function Spots() {
  const [spots, setSpots] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [deletingId, setDeletingId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    getAllSpots();
  }, []);

  const getAllSpots = async () => {
    try {
      setLoading(true);
      const response = await SpotServices.getAllSpots();
      setSpots(response.data || response);
      setLoading(false);
    } catch (err) {
      setError(err.message);
      setLoading(false);
    }
  };

  const handleSpotClick = (spotId, e) => {
    // Don't navigate if delete button was clicked
    if (e.target.closest('.delete-button')) return;
    navigate(`/edit-spot/${spotId}`);
  };

  const handleDeleteSpot = async (spotId, e) => {
    e.stopPropagation(); // Prevent event bubbling to card click
    if (window.confirm('Are you sure you want to delete this spot?')) {
      try {
        setDeletingId(spotId);
        await SpotServices.deleteSpot(spotId);
        setSpots(spots.filter(spot => spot._id !== spotId));
      } catch (err) {
        setError(err.message);
      } finally {
        setDeletingId(null);
      }
    }
  };

  if (loading)
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );

  if (error)
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded">
          Error: {error}
        </div>
      </div>
    );

  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-bold text-gray-800">Tourist Spots</h1>
        <button 
          onClick={() => navigate('/add-spot')}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded"
        >
          Add New Spot
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {spots.map((spot) => (
          <div
            key={spot._id}
            onClick={(e) => handleSpotClick(spot._id, e)}
            className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer relative"
          >
            {/* Delete Button */}
            <button
              onClick={(e) => handleDeleteSpot(spot._id, e)}
              disabled={deletingId === spot._id}
              className="delete-button absolute top-2 right-2 bg-red-500 hover:bg-red-600 text-white p-2 rounded-full z-10"
              title="Delete spot"
            >
              {deletingId === spot._id ? (
                <svg className="animate-spin h-4 w-4 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                </svg>
              )}
            </button>

            {/* Thumbnail Image */}
            <div className="h-48 bg-gray-200 overflow-hidden">
              {spot.thumbnailImage ? (
                <img
                  src={spot.thumbnailImage}
                  alt={spot.name.en}
                  className="w-full h-full object-cover"
                  onError={(e) => {
                    e.target.onerror = null;
                    e.target.src =
                      "https://via.placeholder.com/400x300?text=No+Image";
                  }}
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-gray-100">
                  <span className="text-gray-500">No Image Available</span>
                </div>
              )}
            </div>

            {/* Card Content */}
            <div className="p-6">
              <h2 className="text-xl font-semibold text-gray-800 mb-2">
                {spot.name.en}
                {spot.name.kn && (
                  <span className="block text-sm text-gray-600 mt-1">
                    {spot.name.kn}
                  </span>
                )}
              </h2>

              <p className="text-gray-600 mb-4 line-clamp-2">
                {spot.description}
              </p>

              <div className="flex justify-between items-center">
                <div className="flex space-x-2">
                  {spot.audioGuide.en.isEnabled && (
                    <span className="bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded">
                      EN Audio
                    </span>
                  )}
                  {spot.audioGuide.kn.isEnabled && (
                    <span className="bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                      KN Audio
                    </span>
                  )}
                </div>

                <div className="text-sm text-gray-500">
                  {new Date(spot.createdAt).toLocaleDateString()}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Spots;